// libraries
import type { StateTree } from '@makemydeal/dr-dash-types';
import { registerOfferTypeResolver } from '@makemydeal/dr-dash-components';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';

/**
 * Injected `offerType` axis for read-side telemetry (US2055264).
 *
 * `dash-components` is a generic library and must not import dash offer
 * selectors, so the host app supplies the mapping — the same contract as
 * `screenTelemetryResolver`.
 *
 * WHY A RESOLVER AND NOT AN NR GLOBAL CUSTOM ATTRIBUTE
 * `setCustomAttribute` publishes a value once. Offer type changes mid-session
 * through several paths (the deal-type dropdown actions, `DEAL_TYPE_OVERRIDDEN`,
 * and the unsupported-deal-type override thunk), so a published global would
 * freeze at whichever value happened to be current when it was set, and a single
 * missed path would silently mislabel every subsequent read — data that looks
 * correct and is not. Resolving at emit time from live state cannot go stale,
 * and it costs only the `SelectorRead` stream rather than every PageAction.
 *
 * WHY IT MATTERS
 * The Deal Summary identity chain differs by offer type: finance closes on
 * amount financed, lease on cap cost / adjusted residual / due at signing. A
 * residual check that cannot separate them is not checkable, so this attribute
 * is what makes `FACET offerType` — and the lease identity — queryable at all.
 */
export const registerDashOfferTypeResolver = (): void => {
    registerOfferTypeResolver((state) => offerReduxSelectors.getCurrentOfferType(state as StateTree));
};
